import React, { Component } from "react";
import { inject, observer } from "mobx-react";

import SnackbarNotificationContainer from "./components/Notifications/SnackbarNotificationContainer";
import ErrorCatcher from "./components/ErrorCatcher";
import AppRouter from "./routes/AppRouter";

import KeyboardEventsService from "./services/KeyboardEventsService";

interface IAppProps {}

interface InjectedProps extends IAppProps {
  keyboardEventsService: KeyboardEventsService;
}

@inject("keyboardEventsService")
@observer
class App extends Component<IAppProps> {
  get injected(): InjectedProps {
    return this.props as InjectedProps;
  }
  componentDidMount() {
    document.addEventListener(
      "keydown",
      this.injected.keyboardEventsService.notify,
      false
    );
  }

  componentWillUnmount() {
    document.removeEventListener(
      "keydown",
      this.injected.keyboardEventsService.notify,
      false
    );
  }
  render() {
    return (
      <ErrorCatcher showErrorOnTheScreen>
        <SnackbarNotificationContainer />
        <AppRouter />
      </ErrorCatcher>
    );
  }
}

export default App;
